import { render, staticRenderFns } from "./BookingDates.vue?vue&type=template&id=4224acc1"
import script from "./BookingDates.vue?vue&type=script&lang=js"
export * from "./BookingDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports